"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./styles/CloseButton.scss");
var Button_1 = require("../form/Button");
var CloseButton = function (_a) {
    var handleClick = _a.handleClick, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.ariaAttributes, ariaAttributes = _c === void 0 ? {} : _c;
    var wrapperClass = ['close-button-outer-wrapper', 'unstyled'];
    if (className) {
        wrapperClass.push(className);
    }
    return (React.createElement(Button_1.default, { className: wrapperClass.join(' '), handleClick: handleClick, ariaAttributes: ariaAttributes },
        React.createElement("div", { className: 'close-button-wrapper' },
            React.createElement("div", { className: 'close-button' }))));
};
exports.default = CloseButton;
